import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-input-component',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputComponent),
      multi: true,
    },
  ],
})
export class InputComponent implements ControlValueAccessor {
  @Input() placeholder: string;
  @Output() onClick: EventEmitter<any> = new EventEmitter();
  @Input() formControl: FormControl;
  @Input() type: string;
  @Input() name: string;
  @Input() autofocus: boolean;
  inputValue: string;

  private propagateChange = (_: any): void => { };

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  private propagateTouch = (_: any): void => { };

  registerOnTouched(fn: any): void {
    this.propagateTouch = fn;
  }

  writeValue(value: string): void {
    this.inputValue = value;
  }

  onKeyUp($event: KeyboardEvent): void {
    this.inputValue = (<HTMLInputElement>$event.target).value;
    this.propagateChange(this.inputValue);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/components/InputComponent/input.component.ts